export default "__VITE_ASSET__BhFV0qr3__"